import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { CornerDownLeft, RotateCcw } from "lucide-react";

const SCOPE_LABEL = {
  general: "the bid overall", line_item: "a line item", scope_section: "a scope section",
  drawings: "drawings / takeoff", commercial: "pricing / margin / terms",
};

export default function ApprovalResubmitDialog({ open, onClose, onResubmit, reject, busy }) {
  const [note, setNote] = useState("");
  const close = () => { setNote(""); onClose(); };
  const submit = () => { onResubmit(note.trim() || null); setNote(""); };
  const scope = reject?.context?.scope;
  const where = scope && scope !== "general" ? (reject.context.label || SCOPE_LABEL[scope] || scope) : null;

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent className="max-w-md" data-testid="approval-resubmit-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-slate-900"><RotateCcw className="w-4 h-4 text-[#003E87]" /> Resubmit for approval</DialogTitle>
          <DialogDescription className="text-xs text-slate-500">Your reply goes to the approver next to the original request, so they can see what changed.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {reject && (
            <div className="rounded-md border border-rose-200 bg-rose-50/60 p-3 text-xs" data-testid="resubmit-reviewer-note">
              <div className="font-semibold text-rose-700 flex items-center gap-1.5">
                <CornerDownLeft className="w-3.5 h-3.5" /> {reject.by_name || "Reviewer"} asked for changes{where ? ` on ${where}` : ""}
              </div>
              {reject.comment && <div className="text-rose-700/90 mt-1 italic">“{reject.comment}”</div>}
            </div>
          )}
          <div>
            <Label className="text-xs text-slate-500">What did you change? <span className="text-slate-400">(optional)</span></Label>
            <textarea data-testid="resubmit-note-input" value={note} onChange={(e) => setNote(e.target.value)} rows={3}
              className="mt-1 w-full rounded-md border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#003E87]/20"
              placeholder="e.g. Reworked the racking qty and refreshed BOS pricing" />
          </div>
          <div className="flex justify-end gap-2 pt-1">
            <Button variant="ghost" onClick={close}>Cancel</Button>
            <Button data-testid="resubmit-submit-btn" disabled={busy} onClick={submit} className="bg-[#F4C400] hover:bg-[#e6b000] text-black font-semibold">Resubmit</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
